//, Directive, ElementRef, Renderer, ChangeDetectionStrategy, ViewEncapsulation
import { Component } from '@angular/core';

@Component({
  selector: 'guern-cms',
  template: `<router-outlet></router-outlet> `
})
export class AppComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts